var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { INFINITE_BOUNDS } from "apparatus/driver";
import { P } from "apparatus/library/common";
import { Group, Path, PointText } from "paper";
import { staticImplements } from "types";
let LengthLabel = class LengthLabel {
    constructor() {
        this.shouldUseBoundsCenter = true;
        this.drivers = [
            Object.assign(Object.assign({ type: "rectangle" }, INFINITE_BOUNDS), { toAppearance: (f, p) => f({ startX: p.x, startY: p.y }), fromAppearance: a => P(a.startX, a.startY), scale: 1.0 }),
            Object.assign(Object.assign({ type: "rectangle" }, INFINITE_BOUNDS), { toAppearance: (f, p) => f({ endX: p.x, endY: p.y }), fromAppearance: a => P(a.endX, a.endY), scale: 1.0 }),
        ];
    }
    render(appearance) {
        const swapLabelPositionSign = appearance.swapLabelPosition ? -1 : 1;
        const start = P(appearance.startX, appearance.startY);
        const end = P(appearance.endX, appearance.endY);
        const angle = end.subtract(start).angle;
        const graphic = new Group([]);
        // Add line.
        graphic.addChild(new Path([start, end]).withStroke("default", "black"));
        // Add label.
        const mid = start.add(end).divide(2.0);
        let textPoint = mid;
        let text = new PointText({
            point: textPoint,
            content: start.getDistance(end).toFixed(2),
            fillColor: 'black',
            fontFamily: 'sans-serif',
            fontSize: 15,
            justification: 'center'
        });
        const textWidth = text.bounds.width;
        const textHeight = text.bounds.height;
        textPoint.x += textWidth * Math.sin(angle.toRadians()) / 2 * swapLabelPositionSign;
        textPoint.y += textHeight * Math.cos(angle.toRadians()) / 2 * -swapLabelPositionSign;
        // Math.sin(x * 2) creates a "hump" profile between [0, 1]
        const paddingOffset = P(10 * Math.sin(Math.sin(angle.toRadians()) * 2) * swapLabelPositionSign, -4 * Math.sin(Math.cos(angle.toRadians()) * 2) * swapLabelPositionSign);
        textPoint = textPoint.add(paddingOffset);
        text.position = textPoint;
        graphic.addChild(text);
        return {
            graphic,
            hitShape: graphic.rectHitShape(),
            pivot: P(0, 0)
        };
    }
};
LengthLabel.properties = {
    label: "Length Label",
    defaultAppearance: {
        startX: 0,
        startY: 0,
        endX: 100,
        endY: 0,
        swapLabelPosition: false,
    },
    appearanceSpecs: [
        { spec: "header", header: "Label", icon: "text" },
        {
            spec: "button",
            label: "Swap position",
            onClick: a => ({ swapLabelPosition: !a.swapLabelPosition })
        }
    ],
};
LengthLabel = __decorate([
    staticImplements()
], LengthLabel);
export { LengthLabel };
